// client/src/context/TabVisibilityContext.js
import { createContext } from 'react';

/**
 * Whether the surrounding tab pane is the visible one. Defaults to true so
 * everything behaves normally in the untabbed shell, where there is no provider.
 *
 * Its own module to keep TabHost (which provides it) and the hooks that consume
 * it from importing each other.
 */
const TabVisibilityContext = createContext(true);

export default TabVisibilityContext;
